import { JuloUpdateEntry } from "./types"

export const kommentarshistorikBesiktningEntry: JuloUpdateEntry = {
  slug: "2026-06-10-kommentarshistorik-besiktning",
  date: "2026-06-10",
  title: "Återanvänd tidigare kommentarer i besiktningsprotokollet",
  description:
    'Nu finns en historikknapp i kommentarsfältet på varje komponentkort i besiktningsprotokollet. Klicka på den så ser ni kommentarer som er verkstad tidigare har skrivit för samma komponent — nyaste först. Som standard visas bara kommentarer som hör till den valda åtgärden (t.ex. "Enbart för byt"), men ni kan slå av filtret för att se alla. Klicka på en kommentar så fylls den i direkt i fältet, och listan laddar fler kommentarer allt eftersom ni skrollar.',
  images: [
    {
      src: "/julo-updates/2026-06-10-kommentarshistorik-besiktning/kommentarshistorik.png",
      alt: 'Komponentkortet Kassett i besiktningsprotokollet med kommentarshistoriken öppen under kommentarsfältet: överst filterknappen Enbart för byt, därunder tidigare kommentarer som "Bör bytas ihop med kedjan." med byt-ikonen framför varje rad.',
    },
  ],
}
